// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_cy-0";
export var headerCellHover = "_cy-1";
export var readCellContainer = "_cy-2";
export var unreadIndicator = "_cy-3";